import React, { useState } from "react";
import * as S from "./ChatbotSelectPatient.style";
import { useTranslation } from "react-i18next";
import FlorenzButton from "../../../../florenzComponents/florenzButton/FlorenzButton";
import FlorenzSearchInput from "../../../../florenzComponents/florenceSearchInput/FlorenzSearchInput";
import usePatientList from "../../../../../hooks/usePatientList";
import * as P from "../../../../../utils/pipes";
import ZaiaReaction from "../../../../zaiaComponents/zaiaReaction";
import Popup from "reactjs-popup";
import ProcessName from "../../../shared/processName";

const eventsCalendarEmpty = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/no-results.svg`;
const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;
const logoZaiaAlert = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;
const patientSelectorLogo = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/user-selector.svg`;

function ChatbotSelectPatient({
  closeFunc,
  selectPatient,

  setModalActive,
  patientSelected,
  idAction
}) {
  const { t, i18n: { language } } = useTranslation("global");
  const [inputText, setInputText] = useState('');
  const [selectedPatientTemp, setSelectedPatientTemp] = useState(patientSelected?.id);

  const {
    patientList,
    patientListLoading,
    patientListError
  } = usePatientList()

  console.log("hola", patientList);
  

  const getFilterText = (text) => {
    return inputText 
      ? String(P.removeAccent(text)).toLowerCase().includes(P.removeAccent(inputText).toLowerCase())
      : true
  }

  return (
    <S.ChatbotSelectPatient>
      <div className="header">
        <div className="header__text">Seleccione un paciente</div>
        <img className="header__icon zaia-i-person" src={patientSelectorLogo} alt="select patient" />
      </div>
      <div className="patient-list">
        <div className="searcher">
          <FlorenzSearchInput
            placeholder={t("globally.search")}
            forWhiteBackgroud={true}
            getText={(text) => setInputText(text)}
            borderanimation={false}
          />
        </div>
        <div className="patients">
          {
            patientListError && 
            <div className="users-list__responses">
              <ZaiaReaction
                zaiaImg={logoZaiaAlert}
                text={t("globally.resultAlarm")}
                sizeText="20px"
                textColor="var(--blue-color)"
                widthimg="110px"
              />
            </div>
          }
          {
            patientListLoading && 
            <div className="users-list__responses">
              <ZaiaReaction
                zaiaImg={logoZaiaLoading}
                sizeText="20px"
                textColor="var(--blue-color)"
                widthimg="110px"
              />
            </div>
          }
          {
            !patientListError && !patientListLoading && (patientList?.length === 0 || patientList?.filter((patient) => getFilterText(`${patient.name} ${patient.lastname}`)).length === 0) && 
            <div className="users-list__responses">
              <ZaiaReaction
                zaiaImg={eventsCalendarEmpty}
                text={t("globally.noResults")}
                subText={t("globally.noMatchingPatients")}
                sizeText="33.25px"
                sizeSubText="15px"
                textColor="var(--blue-color)"
                widthimg="210px"
              />
            </div>
          }
          {
            !patientListError && !patientListLoading && patientList?.length !== 0 &&
            patientList?.map((patient) => {
              console.log("avatar", patient);
              
                if(getFilterText(`${patient.name} ${patient.lastname}`)) {
                  return <S.PatientItem
                    key={patient.id}
                    onClick={() => setSelectedPatientTemp(patient)}
                    selected={selectedPatientTemp?.id === patient?.id}
                  >
                    <img src={patient.picture} alt="imgPtc" className="img" />
                    <div className="info">
                      <div className="name">{`${patient.name} ${patient.lastname}`}</div>
                      <div className="process">
                        {
                          <Popup
                            trigger={
                              <div className="patient-option__info-program-detail">
                                {
                                  patient?.userToProcesses.length > 1 
                                  ? <div style={{"textDecoration": "underline"}}>{t("globally.variousProcesses")}</div> 
                                  : <div>{P.dataTranslation(patient?.userToProcesses[0].process?.processName, language)}</div>                                  
                                }
                              </div>
                            }
                            keepTooltipInside
                            nested
                            // position={"right bottom"}
                            on="hover"
                            disabled={patient?.userToProcesses.length > 1 ? false : true}
                          >
                            {
                              <ProcessName userToProcesses={patient?.userToProcesses}/>
                            }
                          </Popup>
                        }
                      </div>
                      <div className="email">{`${patient.email}`}</div>
                    </div>
                  </S.PatientItem>
                } else {
                  return null
                }
              }
            )
          }
        </div>
      </div>
      <div className="footer">
        <div className="button-cancel">
          <FlorenzButton
            size={"s"}
            text={t("globally.cancel")}
            typeStyle={"secondaryWhite"}
            onClick={closeFunc}
          />
        </div>
        <div className="button-select">
          <FlorenzButton
            size={"s"}
            text={t("globally.select")}
            typeStyle={"primary"}
            onClick={() => {
              selectPatient(selectedPatientTemp)
              closeFunc()
            }}

          />
        </div>
      </div>
    </S.ChatbotSelectPatient>
  );
}

export default ChatbotSelectPatient;
